import React from 'react';
import CheckboxTree from 'react-checkbox-tree';
import {
  Icon,
} from '@blueprintjs/core';
import i18n from 'i18n';

export default class CommonCheckboxTree extends CheckboxTree {
  render() {
    return (
      <CheckboxTree
        {...this.props}
        lang={{
          collapseAll: i18n.t('checkboxTree.collapseAll'),
          expandAll: i18n.t('checkboxTree.expandAll'),
          toggle: i18n.t('checkboxTree.toggle'),
        }}
        icons={{
          check: <Icon intent="primary" icon="tick-circle" />,
          uncheck: <Icon intent="primary" icon="circle" />,
          halfCheck: <Icon intent="primary" icon="confirm" />,
          expandClose: <Icon intent="primary" icon="chevron-right" />,
          expandOpen: <Icon intent="primary" icon="chevron-down" />,
          expandAll: <Icon intent="primary" icon="expand-all" />,
          collapseAll: <Icon intent="primary" icon="collapse-all" />,
          parentClose: <Icon intent="primary" icon="folder-close" />,
          parentOpen: <Icon intent="primary" icon="folder-open" />,
          leaf: <Icon intent="primary" icon="document" />,
        }}
      />
    );
  }
}
